import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { DivisionTableColumn } from "../../../Data/DataTables/Divisions";
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewDivision } from "../../../Types/CompanyProfile/Division";

//Modal
import CreateDivisionModal from "../../UiKits/Modal/Division/Create";

//Services
import {
  VIEW_DIVISION_QUERY_KEY,
  divisionService,
} from "../../../Services/divisionService";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const DivisionTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const QueryKey = [...VIEW_DIVISION_QUERY_KEY, company_code];

  const { data: DivisionData = [], isLoading: isDivisionLoading } = useQuery<
    ViewDivision[]
  >({
    queryKey: QueryKey,
    queryFn: () =>
      divisionService.getAllViewDivisionByCompany(company_code as string),
  });

  const filteredItems: ViewDivision[] = DivisionData.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Division Maintenance</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Allows users to create, update, and manage division records to keep
        organizational data accurate and up to date.
      </P>
      <CreateDivisionModal company_code={company_code} />
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={DivisionTableColumn}
          striped={true}
          pagination
          progressPending={isDivisionLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default DivisionTable;
